import { useState } from 'react'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import { useAtomValue } from 'jotai'
import { toastAtom } from '@/atoms/toastAtom'

function BasicControls() {
  const [count, setCount] = useState(0)
  const toast = useAtomValue(toastAtom)

  const handleIncrement = () => {
    setCount(count + 1)
    toast?.show({
      severity: 'info',
      summary: 'カウント増加',
      detail: `カウントが ${count + 1} に増加しました`,
      life: 3000
    })
  }

  const handleReset = () => {
    setCount(0)
    toast?.show({
      severity: 'warn',
      summary: 'リセット完了',
      detail: 'カウントがリセットされました',
      life: 3000
    })
  }

  return (
    <div className="flex flex-column align-items-center">
      <h2 className="text-primary text-xl mb-3">基本コントロール</h2>
      <p className="text-lg mb-4">
        ボタンやその他の基本的なUIコントロールの動作確認
      </p>

      <Divider />

      <div className="my-4 flex flex-row align-items-center justify-content-center gap-2">
        <Button
          icon="pi pi-plus"
          label={`カウント: ${count}`}
          onClick={handleIncrement}
          className="mr-2"
        />
        <Button
          icon="pi pi-refresh"
          label="リセット"
          severity="secondary"
          onClick={handleReset}
        />
      </div>

      <div className="my-4 flex flex-row align-items-center justify-content-center gap-2">
        <Button
          icon="pi pi-check"
          label="成功"
          severity="success"
          className="mr-2"
        />
        <Button
          icon="pi pi-info-circle"
          label="情報"
          severity="info"
          className="mr-2"
        />
        <Button
          icon="pi pi-exclamation-triangle"
          label="警告"
          severity="warning"
          className="mr-2"
        />
        <Button
          icon="pi pi-times"
          label="エラー"
          severity="danger"
        />
      </div>
    </div>
  )
}

export default BasicControls
